<template lang="pug">
  .qty-buttons.xs-f-small.lg-f-xsmall.max-at-tweak
    button.decrement(@click="decrementQty" :class="{ 'disabled': minQtyReached }" :aria-disabled="minQtyReached" data-mr-ass="quantity-down" aria-label='Decrease')
      span.icon-neg.color-mr-purple.clickable

    .qty(data-mr-ass="product-quantity" aria-live="polite" :aria-label="'Quantity ' + localQty" tabindex="0" role="status") {{ localQty }}

    button.increment(@click="incrementQty" :class="{ 'disabled': maxQtyReached }" :aria-disabled="maxQtyReached" data-mr-ass="quantity-up" aria-label='Increase')
      span.icon-pos.color-mr-purple.clickable

</template>

<script>
  import QtyButtonBase from "./QtyButtonBase";

  export default {
    name: "QtyButtons",
    extends: QtyButtonBase
  };
</script>

<style scoped lang="stylus">
  .qty-buttons
    border-radius 5px
    display inline-block

    > *
      display inline-block

    button
      background-color #fff

    .qty
      padding 0.5em 1em
      border 1px solid color-fog

    .decrement
    .increment
      cursor pointer
      padding 0.5em
      border 1px solid color-fog

      &.disabled
        span
          color color-fog

    .decrement
      border-top-left-radius 4px
      border-bottom-left-radius 4px
      border-right none

    .increment
      border-top-right-radius 4px
      border-bottom-right-radius 4px
      border-left none

</style>